import { Component, DoCheck, Input, IterableDiffers, ViewChild } from '@angular/core';
import { OwlChild } from './owl-child.component';

@Component({
  selector: 'owl-carousel',
  template: '<owl-carousel-child #owl [ngClass]="carouselClasses" [options]="options" ><ng-content></ng-content></owl-carousel-child>',
  standalone: false
})
export class OwlCarousel implements DoCheck {
  // View Engine resolved this (non-structural) query statically, before ngOnInit.
  @ViewChild('owl', { static: true }) $owlChild!: OwlChild;
  @Input() carouselClasses: any = '';
  @Input() options: any = {};
  private _items!: any[];
  private differ: any;

  constructor(private differs: IterableDiffers) {}

  @Input() set items(coll: any[]) {
    this._items = coll;
    if (coll && !this.differ) {
      this.differ = this.differs.find(coll).create(null as any);
    }
  }

  ngDoCheck(): void {
    if (this.differ) {
      const changes = this.differ.diff(this._items);
      if (changes) {
        let changed = false;
        const changedFn = () => {
          changed = true;
        };
        changes.forEachAddedItem(changedFn);
        changes.forEachMovedItem(changedFn);
        changes.forEachRemovedItem(changedFn);
        if (changed) {
          this.reInit();
        }
      }
    }
  }

  reInit(): void {
    if (this.$owlChild.$owl) {
      this.$owlChild.$owl.css('display', 'none');
    }
    setTimeout(() => {
      this.$owlChild.destroyOwl();
      if (this.$owlChild.$owl) {
        const itemLength = this._items && this._items.length;
        if (itemLength && itemLength <= this.$owlChild.currentSlideIndex) {
          this.$owlChild.currentSlideIndex = itemLength;
        }
        this.$owlChild.$owl.css('display', 'block');
      }
      this.$owlChild.initOwl();
    }, 0);
  }

  refresh(): void {
    this.trigger('refresh.owl.carousel');
  }

  next(options?: any[]): void {
    this.trigger('next.owl.carousel', options);
  }

  previous(options?: any[]): void {
    this.trigger('prev.owl.carousel', options);
  }

  to(options?: any[]): void {
    this.trigger('to.owl.carousel', options);
  }

  trigger(action: string, options?: any[]): void {
    this.$owlChild.trigger(action, options);
  }
}
